import React, { useEffect, useState } from "react";
import Banner from "../components/Banner";
import { UniversityDescription } from "../components/community-university/UniversityDescription";
import { UniversityTab } from "../components/community-university/UniversityTab";
import { useLocation } from "react-router-dom";
import { useLoader } from "../context/LoaderContext";
import { fetchBuildingForFutureDetails } from "../api/BuildingForFutureApi";
import { dynamicFailed } from "../hooks/custom/useToast";
import { IBuildingForFutureDetailsData } from "../exports/interfaces";

const CommunityUniversityPage = () => {
  const { setLoading } = useLoader();
  const location = useLocation();

  const [buildingForFutureDetails, setBuildingForFutureDetails] = useState<
    IBuildingForFutureDetailsData[]
  >([]);

  useEffect(() => {
    if (!location.hash) {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  }, [location.pathname, location.hash]);

  useEffect(() => {
    setLoading(true);
    Promise.all([fetchBuildingForFutureDetails()])
      .then(([buildingForFutureDetailsData]) => {
        setBuildingForFutureDetails(buildingForFutureDetailsData);
      })
      .catch((error) => {
        dynamicFailed(error.response.data.error.message);
      })
      .finally(() => {
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      });
  }, [setLoading]);

  return (
    <>
      <Banner title="Community" />
      <UniversityDescription
        buildingForFutureDetails={buildingForFutureDetails}
      />
      <UniversityTab />
    </>
  );
};

export default CommunityUniversityPage;
